<template>
    <button type="button" class="popup-link" :disabled="disabled" @click="disabled ? null : onClickAction()">
        {{ noStop }} - {{ name }}
        <IconChevron v-if="!disabled" class="chevron-icon" width="5" height="10" />
    </button>
</template>

<script setup>
import IconChevron from '@@/icons/chevron.svg';

defineProps({
    noStop: {
        type: String,
        default: '',
    },
    name: {
        type: String,
        default: '',
    },
    onClickAction: {
        type: Function,
        default() {
            return (function () {})();
        },
    },
    disabled: {
        type: Boolean,
        default: false,
    },
});
</script>

<style lang="scss">
.leaflet-popup-content {
    margin: 8px 16px;
    width: auto !important;
}
</style>
<style lang="scss" scoped>
.popup-link {
    @include rem-typo(18px);
    display: flex;
    align-items: center;
    gap: 4px;
    color: $color-blue-60;
    background-color: transparent;
    border: 0;
    padding: 0;
    white-space: preserve nowrap;
    &[disabled] {
        cursor: auto;
    }
}
.chevron-icon {
    flex-shrink: 0;
}
</style>
